import { DATE_FORMAT } from '@app/configs/dateTime';
import { getLocalDateTime } from '@app/utils/time';
export const mapScheduleItemsToTableData = (items) => items.map((item) => ({
    id: `schedule-item-${item.position}`,
    position: item.position + 1,
    date: getLocalDateTime(item.date, DATE_FORMAT.dateSlash),
    status: item.status,
    amount: `${item.amountCovered}/${item.amount}`,
    interest: `${item.interestCovered}/${item.interest}`,
    administratorFee: `${item.administratorFeeCovered}/${item.administratorFee}`,
    overdueDays: item.overdueDays,
    lateFee: `${item.lateFeeCovered}/${item.lateFee}`,
    sum: `${item.sumCovered}/${item.sum}`,
}));
